import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: #212325;
  border-radius: 1rem;

  > img {
    border-radius: 1rem;
    width: 6rem;
    height: auto;
    object-fit: cover;
    margin-left: 0.4rem;
  }
  > section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .description {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4; /* number of lines to show */
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
`;
